// Shows the selected variant's INCI list (hair colour shades).
document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

  for (const list of document.querySelectorAll('[data-faq-variant-inci]')) {
    const { productId } = list.dataset;
    const items = [...list.querySelectorAll('[data-variant-id]')];

    subscribe(PUB_SUB_EVENTS.variantChange, (data) => {
      if (data.productId !== productId || !data.variant) return;

      for (const item of items) {
        item.classList.toggle('hidden', item.dataset.variantId !== String(data.variant.id));
      }
    });
  }
});
